module.exports = __webpack_public_path__ + "assets/images/gender_y.a14c62da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/gender_y.png
// module id = 716
// module chunks = 1